<template>
  <div class="system-dic-container layout-padding">
    <el-card shadow="hover" class="layout-padding-auto">
      <div class="system-user-search mb15">
        <el-input
          v-model="queryData.searchValue"
          size="small"
          placeholder="请输入"
          style="max-width: 180px"
        >
        </el-input>
        <el-button
          size="small"
          type="primary"
          class="ml10"
          @click="queryTableData"
        >
          <el-icon>
            <ele-Search />
          </el-icon>
          查询
        </el-button>
        <el-button
          size="small"
          type="success"
          class="ml10"
          @click="onOpenAddDic({})"
        >
          <el-icon>
            <ele-FolderAdd />
          </el-icon>
          新增
        </el-button>
        <el-button
          size="small"
          type="warning"
          class="ml10"
          @click="gotoSetTemplate"
        >
          <el-icon>
            <ele-FolderAdd />
          </el-icon>
          模板管理
        </el-button>
      </div>
      <el-table :data="tableData" v-loading="loading" style="width: 100%">
        <el-table-column type="index" label="序号" width="50" />
        <el-table-column
          prop="TalentName"
          label="项目名"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          prop="TalentCode"
          label="唯一标识"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column prop="typeShow" label="表单类型" show-overflow-tooltip>
          <template #default="scope">
            {{ getType(scope.row.Type) }}
          </template>
        </el-table-column>
        <el-table-column label="操作" width="100">
          <template #default="scope">
            <el-button
              size="small"
              text
              type="text"
              @click="onOpenEditDic(scope.row)"
              >修改</el-button
            >
            <el-button
              size="small"
              text
              type="text"
              @click="onRowDel(scope.row)"
              >删除</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <!-- <el-pagination @size-change="onHandleSizeChange" @current-change="onHandleCurrentChange" class="mt15"
                  :pager-count="5" :page-sizes="[10, 20, 30]" v-model:current-page="queryData.page" background
                  v-model:page-size="queryData.pageSize" layout="total, sizes, prev, pager, next, jumper" :total="total">
              </el-pagination> -->
    </el-card>
    <dicDialog
      :dicList="typeList"
      ref="dicDialogRef"
      @refresh="queryTableData()"
    ></dicDialog>
    <!-- 模板管理 -->
    <el-dialog
      title="模板"
      :visible.sync="dialogVisible"
      width="500px"
      :before-close="handleClose"
    >
      <div v-loading="dialogLoading">
        <!-- 0 报名信息  1积分认定  2层次认定  3积分认定模板  4层次认定模板  5和10 后台文件  6 报名模板 7 企业人才模板 -->
        <el-upload
          class="upload-demo"
          :action="getUploadUrl"
          :on-preview="handlePreview"
          :on-remove="handleRemove"
          :before-remove="beforeRemove"
          :before-upload="beforeUpload"
          :on-success="onSuccess"
          :limit="1"
          :data="{ Type: 13 }"
          accept=".doc, .docx, .xls, .xlsx"
          :on-exceed="handleExceed"
          :file-list="fileList"
        >
          <el-button size="small" type="primary">点击上传</el-button>
          <div slot="tip" class="el-upload__tip">
            只能上传doc/docx/xls/xlsx文件，且不超过1000kb
          </div>
        </el-upload>
      </div>
      <span slot="footer" class="dialog-footer" v-loading="dialogLoading">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="submitUpdateTemFile">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import {
  GetTalentTaletnDatilList,
  DeleteTalentDic,
  GetFiletemplate,
  UploadIntegralFile,
} from "@/api/talentIdentification/talentIdentification";
import { GetSysDictByCode } from "@/api/SysDictionary/SysDictionary";
import dicDialog from "./companyDialog.vue";
import * as Api from "../../api/api";

export default {
  name: "cengci",
  components: { dicDialog },
  data() {
    return {
      fileList: [],
      fileInfoId: "",
      dialogVisible: false,
      dialogLoading: false,
      loading: false,
      tableData: [],
      total: 0,
      queryData: {
        page: 1,
        pageSize: 10,
        searchValue: "",
      },
      typeDic: {},
      typeList: [],
    };
  },
  computed: {
    getType() {
      return function (code) {
        return this.typeDic[code];
      };
    },
    getUploadUrl() {
      return Api.uploadUrl;
    },
  },
  methods: {
    handleRemove(file, fileList) {
      this.fileList = [];
    },
    onSuccess(response, file, fileList) {
      let url = response.response.Url;
      let name = response.response.FileName;
      this.fileList = [{ url, name }];
    },
    handlePreview(file) {},
    handleExceed(files, fileList) {
      this.$message.warning(`对多只能上传一个模板`);
    },
    beforeRemove(file, fileList) {
      return this.$confirm(`确定移除 ${file.name}？`);
    },
    beforeUpload(file) {
      return true;
    },
    gotoSetTemplate() {
      this.fileList = [];
      this.dialogVisible = true;
      this.HttpGetFiletemplate({ talenttype: 3 }); //1:积分人才认定模板，2层次人才认定模板 3企业人才认定模板
    },
    handleClose() {
      this.dialogVisible = false;
    },
    onRowDel(row) {
      let that = this;
      this.$confirm("是否删除该数据？", "提示", {}).then(() => {
        that.HttpDeleteTalentDic({ ids: row.Id });
      });
    },
    onOpenAddDic(row) {
      this.$refs.dicDialogRef.openDialog(row, "add");
    },
    onOpenEditDic(row) {
      this.$refs.dicDialogRef.openDialog(row, "edit");
    },
    queryTableData() {
      let param = {
        page: this.queryData.page,
        intPageSize: this.queryData.pageSize,
        searchValue: this.queryData.searchValue,
        talenttype: 3, //0：全部，1积分人才，2层次人才
      };
      this.HttpQueryTaletnDatilList(param);
    },
    onHandleSizeChange(val) {
      this.queryData.pageSize = val;
      this.queryTableData();
    },
    onHandleCurrentChange(val) {
      this.queryData.page = val;
      this.queryTableData();
    },
    submitUpdateTemFile() {
      if (!Boolean(this.fileList && this.fileList.length)) {
        this.$message.error("请上传模板");
        return;
      }
      let param = {
        FileTemplateName: this.fileList[0].name,
        FilePath: this.fileList[0].url,
        TalentType: 3, //上传文件类型 1:积分人才信息模板 2：层次人才信息模板
        Id: this.fileInfoId,
      };
      this.HttpUploadIntegralFile(param);
    },
    //Http查询列表
    async HttpQueryTaletnDatilList(param) {
      this.loading = true;
      const res = await GetTalentTaletnDatilList(param);
      this.loading = false;
      if (res.data.status == 200) {
        let raw = res.data.response || [];
        // raw.forEach((o) => {
        //     o.typeShow = this.typeDic[o.Type]
        // })

        this.tableData = raw;
      } else {
        this.$message.error(res.data.msg);
      }
    },
    async HttpDeleteTalentDic(param) {
      const response = await DeleteTalentDic(param);
      let res = response.data || {};
      if (res.status == 200) {
        this.queryTableData();
        this.$message({
          message: "操作成功",
          type: "success",
        });
      } else {
        this.$message({
          message: res.msg,
          type: "error",
        });
      }
    },
    async HttpUploadIntegralFile(param) {
      const response = await UploadIntegralFile(param);
      let res = response.data || {};
      if (res.status == 200) {
        this.dialogVisible = false;
        this.$message({
          message: "操作成功",
          type: "success",
        });
      } else {
        this.$message({
          message: res.msg,
          type: "error",
        });
      }
    },
    async HttpQueryDicByCode(params) {
      const response = await GetSysDictByCode(params);
      let res = response.data || {};
      if (res.status == 200) {
        let raw = res.response || [];
        let result = {};
        this.typeList = raw;
        raw.forEach((o) => {
          result[o.ItemValue] = o.ItemText;
        });
        this.typeDic = result;
      } else {
        this.$message.error(res.msg);
      }
    },
    async HttpGetFiletemplate(param) {
      this.dialogLoading = true;
      const response = await GetFiletemplate(param);
      this.dialogLoading = false;
      let res = response.data || {};

      if (res.status == 200) {
        let raw = res.response;
        let fileInfo = raw || {};
        fileInfo.name = fileInfo.FileTemplateName;
        fileInfo.url = fileInfo.url;
        this.fileInfoId = fileInfo.Id;
        this.fileList = [fileInfo];
      } else {
        this.$message.error(res.msg);
      }
    },
  },

  mounted() {
    this.HttpQueryDicByCode({ code: "Form_Type" });
    this.queryTableData();
  },
};
</script>

<style scoped></style>
